import { render, staticRenderFns } from "./RemoteHeader.vue?vue&type=template&id=404a2d80&scoped=true"
import script from "./RemoteHeader.vue?vue&type=script&lang=js"
export * from "./RemoteHeader.vue?vue&type=script&lang=js"
import style0 from "./RemoteHeader.vue?vue&type=style&index=0&id=404a2d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404a2d80",
  null
  
)

export default component.exports